import { GetStaticProps, GetStaticPaths } from 'next';
import { getLanguagesPaths } from '~/utils/translate';
import { CompletedDashboard } from '~/components/completed-dashboard';
import { withAuth, useAuth } from '~/auth';
// import { AccountStatuses } from '~/auth/use-account-status';
import useUserProfile from '~/apis/useUserProfile';
import { SubmitLoader } from '~/components/common/loaders/submit';
// import router from 'next/router';
import { useTranslate } from '~/i18n';
import { NextSeo } from 'next-seo';
import { OnBoarding } from '~/components/onboarding';
import { IncompleteDashboard } from '~/components/incomplete-dashboard';

const DashboardPage = () => {
   const { user, updateUser } = useAuth();
   const { translate } = useTranslate();

   // const { status } = useAccountStatus();
   const { isLoading } = useUserProfile({
      onSuccess: data => {
         if (data && data.status) {
            updateUser({ ...user, ...data });
         }
      },
   });

   if (isLoading)
      return (
         <div className="flex w-full justify-center">
            <SubmitLoader />
         </div>
      );
   const {
      profile_strength: { published_first_product, account_created, verified_business_profile },
      uploaded_legal_docs,
   } = user || {};
   // const businessProfileComplete = user?.business_name;
   // //&& user?.business_categories?.length && user?.contract_info?.plan_id;

   if (user && (!uploaded_legal_docs || user.status === 'Under Review')) {
      return <OnBoarding />;
   }

   if (account_created && published_first_product && verified_business_profile)
      return (
         <div>
            <NextSeo
               title={translate({
                  id: 'pageTitles:dashboard',
               })}
            />
            <CompletedDashboard />
         </div>
      );
   return (
      <div>
         <NextSeo
            title={translate({
               id: 'pageTitles:dashboard',
            })}
         />
         <IncompleteDashboard />
      </div>
   );
};

export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};

export default withAuth(DashboardPage);
